export interface SummaryDetails {
  data: {
    summary: Details[];
    documents: any;
  };
}
export interface Details {
  title: string;
  count?: number;
  type?: EDetailsType;
  noSubtitle?: boolean;
  value: any;
  icon?: EIconType;
  displayFields?: string[];
}

export enum EDetailsType {
  DETAIL = 'DETAIL',
  DOC = 'DOC',
  BIG_DETAIL = 'BIG_DETAIL',
  MULTI_APPLICANT = 'MULTI_APPLICANT',
  LAND_DETAIL = 'LAND_DETAIL',
  LAND_SALE_DETAILS = 'LAND_SALE_DETAILS',
  LAND_AND_SALE = 'LAND_AND_SALE',
  BUYER_DETAILS = 'BUYER_DETAILS',
  SELLER_DETAILS = 'SELLER_DETAILS',
  PARCEL_REPRESENTATIVE = 'PARCEL_REPRESENTATIVE',
}

export enum EIconType {
  USER = 'USER',
  USERS = 'USERS',
  OFFICE = 'OFFICE',
  DOCS = 'DOCS',
  CONTACT = 'CONTACT',
  OTHER = 'OTHER',
}
